<template>
  <section>
    <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :close-css="{top: '8px', right: '5px' }" :show-close="true" :error-msg="errorMsg" @close="closeDialog" />
    <sys-loading :loading="loading" />
    <div class="container" v-if="!isMobile">
        <div class="left-side">
            <img class="title" src="../assets/euro/img-title.png" alt="">
            <div class="loop">
                <swiper ref="rightSlide" :options="swiperOptions2">
                    <swiper-slide v-for="index in 5" :key="index">
<!--                        <a href="https://vnn8d.com/" target="_blank"></a>-->
                        <img :src="require(`../assets/euro/img-swiper${index}.png`)" alt="" width="100%" />
                    </swiper-slide>
                </swiper>
                <div class="prev-btn2 nav-btn" slot="button-prev"></div>
                <div class="next-btn2 nav-btn" slot="button-next"></div>
            </div>
        </div>
        <div class="right-side">
            <img class="logo" src="../assets/euro/logo.png" />
            <div class="form">
          <div class="tag">
            <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="isRegisterAction = true">
              ĐĂNG KÝ
            </div>
            <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="isRegisterAction = false">
              ĐĂNG NHẬP
            </div>
          </div>
          <div class="form-input" style="--size:10em">
            <img src="../assets/euro/icon-user.png" />
            <input v-model="form.userName" placeholder="Nhập tên đăng nhập *" maxlength="20" autocomplete="off" />
          </div>
            <span class="error-tips">{{ validateMsg.userName }}</span>
          <div class="form-input" style="--size:7.5em">
            <img src="../assets/euro/icon-password.png" />
              <input v-model="form.password" :type="showPwd ? 'text' : 'password'" autocomplete="new-password" placeholder="Nhập mật khẩu *" />
              <img class="last-icon" :src="require(`../assets/euro/icon-${showPwd ? 'show':'hide'}.png`)" @click="showPwd=!showPwd" />
          </div>
            <span class="error-tips">{{ validateMsg.password }}</span>
          <div class="form-input" v-show="isRegisterAction" :style="!isRegisterAction ? { marginBottom: 0 } : ''" style="--size:9.5em">
            <img src="../assets/euro/icon-password.png" />
            <input v-model="form.checkPass" :type="showRePwd ? 'text' : 'password'" autocomplete="new-password" placeholder="Xác nhận mật khẩu *" />
              <img class="last-icon" :src="require(`../assets/euro/icon-${showRePwd ? 'show':'hide'}.png`)" @click="showRePwd=!showRePwd" />
          </div>
            <span class="error-tips" v-show="isRegisterAction">{{ validateMsg.checkPass }}</span>
          <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;--size:9em;">
              <img src="../assets/euro/verify-code.png" />
            <input v-model="form.verificationCode" autocomplete="off" maxlength="4" placeholder="Nhập mã xác minh *"/>
            <div class="codeImg">
              <span @click="getVerify" v-if="codeImg" class="validateCode">
                <img class="img" :src="codeImg" alt="code" />
              </span>
            </div>
          </div>
            <span class="error-tips" v-show="isRegisterAction">{{ validateMsg.verificationCode }}</span>
          <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" :vstyle="{
              padding: '30px 30px 0',
              position: 'relative',
              'box-sizing': 'border-box'
            }" @cb="handleConfirm">
            <div v-show="isRegisterAction" class="btn" @click="submitAction(1)">
                <img src="../assets/euro/btn-reg.gif" alt="">
            </div>
          </v-captcha>
          <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
              <img src="../assets/euro/btn-login.gif" alt="">
          </div>
        </div>
            <div class="contact">
            <a href="https://www.messenger.com/t/8day2021" target="_blank">
                <img src="../assets/euro/facebook.png" alt="">
            </a>
            <a href="https://t.me/cskh8day" target="_blank">
                <img src="../assets/euro/telegram.png" alt="">
            </a>
        </div>
      </div>
    </div>
    <div class="root" v-if="isMobile">
      <img class="logo" src="../assets/8day-logo.png" />
      <img class="title" src="../assets/euro/img-title.png" />
        <div class="h5-loop">
            <swiper ref="rightSlide" :options="swiperOptions2">
                <swiper-slide v-for="index in 5" :key="index">
<!--                    <a href="https://vnn8d.com/" target="_blank"></a>-->
                    <img :src="require(`../assets/euro/img-swiper${index}.png`)" alt="" width="100%" />
                </swiper-slide>
            </swiper>
            <div class="prev-btn2 nav-btn" slot="button-prev"></div>
            <div class="next-btn2 nav-btn" slot="button-next"></div>
        </div>
      <div class="tag">
        <div class="tag-item reg" :class="isRegisterAction ? 'active' : ''" @click="isRegisterAction = true">
          ĐĂNG KÝ
        </div>
        <div class="tag-item login" :class="!isRegisterAction ? 'active' : ''" @click="isRegisterAction = false">
          ĐĂNG NHẬP
        </div>
      </div>
      <div class="form">
        <div class="form-input" style="--size:10em">
          <img src="../assets/euro/icon-user.png" />
          <input v-model="form.userName" placeholder="Nhập tên đăng nhập *" maxlength="20" autocomplete="off" />
        </div>
          <span class="error-tips">{{ validateMsg.userName }}</span>
        <div class="form-input" style="--size: 7.5em;">
          <img src="../assets/euro/icon-password.png" />
          <input v-model="form.password" :type="showPwd ? 'text' : 'password'" autocomplete="new-password" placeholder="Nhập mật khẩu *" />
            <img class="last-icon" :src="require(`../assets/euro/icon-${showPwd ? 'show':'hide'}.png`)" @click="showPwd=!showPwd" />
        </div>
          <span class="error-tips">{{ validateMsg.password }}</span>
        <div class="form-input" v-show="isRegisterAction" :style="!isRegisterAction ? { marginBottom: 0 } : ''" style="--size: 9.5em;">
          <img src="../assets/euro/icon-password.png" />
            <input v-model="form.checkPass" :type="showRePwd ? 'text' : 'password'" autocomplete="new-password" placeholder="Xác nhận mật khẩu *" />
            <img class="last-icon" :src="require(`../assets/euro/icon-${showRePwd ? 'show':'hide'}.png`)" @click="showRePwd=!showRePwd" />
        </div>
          <span class="error-tips" v-if="isRegisterAction">{{ validateMsg.checkPass }}</span>
        <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0;position: relative;--size: 9em;">
            <img src="../assets/euro/verify-code.png" />
          <input v-model="form.verificationCode" autocomplete="off" maxlength="4" placeholder="Nhập mã xác minh *" />
          <div class="codeImg">
            <span @click="getVerify" v-if="codeImg" class="validateCode">
              <img class="img" :src="codeImg" alt="code" />
            </span>
          </div>
        </div>
          <span class="error-tips" v-show="isRegisterAction">{{ validateMsg.verificationCode }}</span>
        <v-captcha ref="vcaptcha2" :dialogVisible="dialogVisible" :showCheck="showCheck" :vstyle="{
            padding: '30px 30px 0',
            position: 'relative',
            'box-sizing': 'border-box'
          }" @cb="handleConfirm">
          <div v-show="isRegisterAction" class="btn" @click="submitAction(1)">
              <img src="../assets/euro/btn-reg.gif" alt="">
          </div>
        </v-captcha>
        <div v-show="!isRegisterAction" class="btn" @click="submitAction(2)">
            <img src="../assets/euro/btn-login.gif" alt="">
        </div>
      </div>
        <div class="contact">
            <a href="https://www.messenger.com/t/8day2021" target="_blank">
                <img src="../assets/euro/facebook.png" alt="">
            </a>
            <a href="https://t.me/cskh8day" target="_blank">
                <img src="../assets/euro/telegram.png" alt="">
            </a>
        </div>
    </div>
  </section>
</template>

<script>
import md5 from "js-md5";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE,
  CONTRACTS
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import {encodePlatformUrl, validForm, isMobile, newValidForm} from "../utils/tools";
import { captcha } from "@/mixins/captcha";
export default {
  name: "Euro",
  mixins: [captcha],
  components: { swiper, swiperSlide },
  data() {
    return {
        showPwd:false,
        showRePwd:false,
      codeImg: '',
      isMobile: isMobile(),
      loading: false,
      isRegisterAction: true,
      dialogVisible: false,
      dialogBgi: require("../assets/euro/bgi-dialog.png"),
      // closeImageUrl: require("../assets/euro/icon-close.png"),
      contacts: CONTRACTS,
      form: {
          by: 1,
          userName: "",
          verificationCode: "",
          password: "",
          checkPass: "",
          link: "",
          domain: "",
          inviteCode: null,
      },
      errorMsg: {
        title: "",
        content: ""
      },
        validateMsg: {},
      swiperOptions2: {
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        effect: "slide",
        navigation: {
          nextEl: ".next-btn2",
          prevEl: ".prev-btn2"
        }
      }
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
    watch:{
      isRegisterAction: {
           handler(val) {
              this.form = {
                  userName: "",
                  verificationCode: "",
                  password: "",
                  checkPass: "",
                  link: "",
                  domain: "",
                  inviteCode: null,
              }
              this.validateMsg = {};
          },
          immediate: true
      }
    },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(type) {
      this.validateMsg = newValidForm(type, this.form);
      if (Object.keys(this.validateMsg).length !== 0) {
          console.error(this.validateMsg)
        return;
      }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.userName,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = (this.inviteCodeObj && this.inviteCodeObj[location.host]) || DOMAIN_AGENT_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
        
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.isSlot=false;
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.isSlot=false;
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        this.loading = false;
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.verificationCode = this.form.verificationCode;
      params.by = 1;
      userRegister(params, this.captchaParams).then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    min-width: 1920px;
    height: 100vh;
    background-image: url("../assets/euro/bgi-pc.jpg");
    background-size: 100% 100%;
    overflow: hidden;
    position: relative;

  .right-side {
    width: 60%;
    height: 100%;
    float: right;
    text-align: center;
    display: flex;
    flex-flow: column;
    align-items: center;
      position: relative;
      right: 100px;

    img.logo {
        width: 299px;
        height: 176px;
        margin-top: 45px;
    }

    .form {
      background-image: url("../assets/sport/bgi-form.png");
      background-size: 100% 100%;
      position: relative;
      width: 27.6563vw;
      margin: 30px auto 0;
      padding-top: 70px;
      padding-bottom: 10px;
      position: relative;
        padding-bottom: 70px;

      a {
        color: #00ffe6;
        position: relative;
        top: 20px;
      }

      .tag {
        width: 100%;
        height: 4.375vw;
        line-height: 40px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: absolute;
        top: -2vw;

        .tag-item {
          width: 40%;
            height: 53px;
          color: #888888;
          font-size: 24px;
          font-style: normal;
          font-weight: 800;
          line-height: 3.4895vw;
          cursor: pointer;
          background-image: url("../assets/euro/bgi-tag.png");
          background-size: 100% 100%;
        }

        .active {
          background-image: url("../assets/euro/bgi-tag-act.png");
          background-size: 100% 100%;
          width: 55.7%;
          height: 79px;
          line-height: 4.375vw;
          font-size: 40px;
            color: #00d8e6;
        }
      }

      .form-input {
        width: 80%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 7px 20px;
        background-size: 100% 100%;
        transition: all 0.25s ease;
        border-radius: 50px;
        background: white;

        .codeImg {
          cursor: pointer;
            width: 125px;
          height: 34px;
          position: absolute;
          right: 22px;
          top: 11px;
          .img {
            margin-right: 0;
            height: 100%;
            border-radius: 15px;
          }
        }

        img {
          margin-right: 10px;
        }

        input {
          border: none;
          outline-width: 0;
          background-color: transparent;
          height: 34px;
          width: 300px;
          font-family: UTMAvo;
          font-weight: 500;
          font-size: 20px;
          color: #5A5A5A;
          padding: 1px 2px;
        }

        input::placeholder {
          color: #5A5A5A73;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;

            font-style: 1em;
            background: linear-gradient(to right, #5A5A5A73 0, #5A5A5A73 var(--size), #016560 var(--size));
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;

        }

          .last-icon {
              position: absolute;
              right: 34px;
              cursor: pointer;
          }

      }
        .error-tips {
            display: flex;
            margin: 8px 0 8px 77px;
            color: #fff;
            font-size: 20px;
            font-weight: 500;
            line-height: 24px;
            min-height: 24px;
        }
      .btn {
        width: 705px;
        height: 180px;
        background-image: url("../assets/euro/btn-bg.png");
        background-size: 100% 100%;
        cursor: pointer;
        position:absolute;
        left: -18%;
          bottom: -150px;
          img{
              width: 320px;
              height: 89px;
              position: relative;
              top: -28px;
          }
      }
    }

      .contact {
          position: relative;
            top: 40px;
          display: flex;
          column-gap: 23px;
          img{
              width: 83px;
              height: 83px;
          }
      }
  }

  .left-side {
    width: 40%;
    height: 100%;
    float: left;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;

      img.title {
          position: relative;
          left: 336px;
          top: 43px;
          width: 604px;
          height: 168px;
          margin-bottom: 30px;
      }


    .loop {
      width: 400px;
      height: 602px;
      position: relative;
      left: 55%;
      cursor: pointer;

      .swiper-container {
        img {
            position: relative;
          width: 374px;
          height: 602px;
            left: 15px;
        }
      }

      .nav-btn {
        width: 28px;
        height: 53px;
        position: absolute;
        top: 40%;
      }

      .prev-btn1,
      .prev-btn2 {
        left: -70px;
        background-image: url("../assets/euro/icon-left.png");
        background-size: 100% 100%;
      }

      .next-btn1,
      .next-btn2 {
        right: -70px;
        background-image: url("../assets/euro/icon-right.png");
        background-size: 100% 100%;
      }
    }
  }
}
.root {
  width: 100%;
  height: 107vh;
  background-image: url("../assets/euro/bgi-mb.jpg");
  background-size: 100% 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-bottom: 2vh;

  img.logo {
    width: 29.21vw;
    margin-top: 3vh;
  }

  img.title {
      margin-top: 3vh;
    width: 62%;
  }

    .h5-loop {
        width: 50vw;
        height: 32vh;
        position: relative;
        cursor: pointer;

        .swiper-container {
            img {
                position: relative;
                width: 46vw;
                height: 34vh;
                left: 4vw;
            }
        }

        .nav-btn {
            width: 3vw;
            height: 3vh;
            position: absolute;
            top: 40%;
        }

        .prev-btn1,
        .prev-btn2 {
            left: -2vw;
            background-image: url("../assets/euro/icon-left.png");
            background-size: 100% 100%;
        }

        .next-btn1,
        .next-btn2 {
            right: -6vw;
            background-image: url("../assets/euro/icon-right.png");
            background-size: 100% 100%;
        }
    }

  .tag {
    display: flex;
    align-items: flex-end;
    line-height: 40px;
    position: relative;
    top: 7vw;
    z-index: 999;
      width: 80vw;

    .tag-item {
      width: 40%;
      height: 8.9333vw;
      background-image: url("../assets/euro/bgi-tag.png");
      background-size: 100% 100%;
        color: #888888;
      font-size: 1em;
      text-align: center;
      font-style: normal;
      font-weight: 800;
    }

    .active {
      width: 60%;
      height: 11.2vw;
      background-image: url("../assets/euro/bgi-tag-act.png");
      background-size: 100% 100%;
      line-height: 11.2vw;
      font-size: 1.1em;
      text-align: center;
        color: #00d8e6;
    }
  }

  .form {
    height: fit-content;
    width: 84vw;
    padding-top: 10vw;
    background-image: url("../assets/euro/bgi-form.png");
    background-size: 100% 100%;
    position: relative;
      padding-bottom: 5vh;

    a {
      color: #00ffe6;
      text-align: center;
      display: block;
      padding-top: 2vw;
    }

    .form-input {
      width: 80%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 5px 10px;
      background-size: 100% 100%;
      transition: all 0.25s ease;
      background: rgba(255, 255, 255,1);
      border-radius: 8vw;

      img {
        margin-right: 1vw;
      }

      .codeImg {
        cursor: pointer;
        width: 20vw;
        height: 100%;
        position: absolute;
        right: 1vw;
        top: 0.5vh;
        .img {
          width: 20vw;
          height: 4vh;
            border-radius:4vh;
        }
      }

      input {
        font-family: UTMAvo;
        border: none;
        outline-width: 0;
        background-color: transparent;
        height: 7.29vw;
        font-size: 1em;
        color: #5A5A5A;
          &::placeholder {
              color: #5A5A5A73;
              font-size: 1em;
              font-style: normal;
              font-weight: normal;
              font-style: 1em;
              background: linear-gradient(to right, #5A5A5A73 0, #5A5A5A73 var(--size), #016560 var(--size));
              background-clip: text;
              -webkit-background-clip: text;
          }
      }
        .last-icon{
            position: absolute;
            right: 6vw;
            cursor: pointer;
        }
    }

      .error-tips {
          display: flex;
          margin: 0.25vh 0;
          color: #fff;
          font-size: 1em;
          font-weight: 500;
          line-height: 1.2em;
          padding-left: 15vw;
          min-height: 2.2vh;
      }

    .btn {
      width: 100vw;
      height: 10vh;
      line-height: 7vh;
      text-align: center;
      margin: 0 auto;
      font-size: 1.5em;
      font-weight: bold;
      color: #ffffff;
      position: absolute;
      bottom: -8vh;
        left: -8vw;
      background-image: url("../assets/euro/btn-bg.png");
      background-size: 100% 100%;

      img {
        position: relative;
        top: -2vh;
        width: 50vw;
      }
    }
  }
    .contact {
        position: relative;
        top: 4vh;
        display: flex;
        column-gap: 10vw;
        img{
            width: 10vw;
            height: 10vw;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Euro.vue